import {
  UserOutlined,
  MailOutlined,
  UploadOutlined,
  SafetyCertificateOutlined,
  DeleteOutlined,
  ClearOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, message, Input, Select, Upload, Popconfirm, Collapse } from "antd";
import SignaturePad from 'signature_pad';
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  SelectItem,
  InputNumberItem,
  InputItem,
  ErrorItem,
  SwitchItem,
  ButtonItem,
  TransferItem,
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";
import PermisosUsuarioEditor from "../PermisosUsuarioEditor";
import LeyendaModulosLimitarProyectos from "../LeyendaModulosLimitarProyectos";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import SegmentedItem from "../../../../Components/SegmentedItem";

const { Option } = Select;

class EditarUsuario extends Component {
  formRef = React.createRef();
  canvasRef = React.createRef();
  sigPad = null;
  state = {
    loading: false,
    todasPerfiles: null,
    objetoPerfiles: null,
    perfilIdSel: null,
    permisosUsuario: [],
    firmaActual: null,
    firmaData: null,
    firmaMode: 'subir',
    loadingFirma: false,
    historicoFirmas: [],
    loadingHistorico: false,
  };
  componentDidMount() {
    axios.post("usuariosBiwo/selectCatalogosUsuarios", {}, { headers: this.props.headersToken }).then((res) => {
      if (res.data.success === 2) this.setState({ opcionesDepartamentos: res.data.departamentos.map((d) => ({ value: d.clave, label: d.nombre })) });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }
  cerrarEditarUsuario(codigo) {
    if (this.sigPad) {
      this.sigPad.off();
      this.sigPad = null;
    }
    this.setState({ firmaActual: null, firmaData: null, firmaMode: 'subir', historicoFirmas: [] });
    this.formRef.current.resetFields();
    this.props.cerrarEditarUsuario(codigo);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "perfiles/selectPerfiles",
        { usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            todasPerfiles: res.data,
            objetoPerfiles: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre + " - " + value.descripcion}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectosPEmpresa",
        { usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
        }
      });
    await axios
      .post(
        "usuarios/datosUsuario",
        { usuarioPrincipal: this.props.usuarioPrincipal, usuarioId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro informacion del usuario");
        } else {
          this.formRef.current.setFieldsValue({ ...res.data });
          const permisosUsuario = Array.isArray(res.data.permisosUsuario)
            ? res.data.permisosUsuario.map((p) => ({
                permisoId: p.permisoId.toString(),
                activado: p.activado,
                valor: p.valor ?? null,
              }))
            : [];
          const perfilIdSel =
            this.formRef.current.getFieldValue("perfilId") ||
            res.data.perfilId ||
            res.data.perfil?._id ||
            res.data.perfil ||
            null;
          this.setState({ perfilIdSel, permisosUsuario, firmaActual: null, firmaData: null });
        }
      });
    this.setState({ loading: false });
  }
  onChangeValoresForm = (changed) => {
    if ("perfilId" in changed) {
      this.setState({ perfilIdSel: changed.perfilId });
    }
  };
  initSignaturePad() {
    setTimeout(() => {
      if (this.canvasRef.current) {
        if (this.sigPad) this.sigPad.off();
        this.sigPad = new SignaturePad(this.canvasRef.current);
      }
    }, 150);
  }
  guardarFirma() {
    let firmaToSend;
    if (this.state.firmaMode === 'dibujar') {
      if (!this.sigPad || this.sigPad.isEmpty()) {
        message.warning('Por favor dibuja tu firma antes de guardar');
        return;
      }
      firmaToSend = this.sigPad.toDataURL('image/png');
    } else {
      if (!this.state.firmaData) {
        message.warning('Por favor selecciona una imagen');
        return;
      }
      firmaToSend = this.state.firmaData;
    }
    this.setState({ loadingFirma: true });
    axios
      .post(
        'usuarios/guardarFirma',
        { usuarioId: this.props.id, usuarioPrincipal: this.props.usuarioPrincipal, firma: firmaToSend },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingFirma: false });
        if (res.data.success === 2) {
          message.success('Firma guardada correctamente');
          this.setState({ firmaActual: firmaToSend, firmaData: null });
          if (this.sigPad) this.sigPad.clear();
          this.consultarHistoricoFirmas();
        } else {
          message.error('No se pudo guardar la firma');
        }
      })
      .catch(() => {
        this.setState({ loadingFirma: false });
        message.error('Error al guardar la firma');
      });
  }
  borrarFirma() {
    this.setState({ loadingFirma: true });
    axios
      .post(
        'usuarios/borrarFirma',
        { usuarioId: this.props.id, usuarioPrincipal: this.props.usuarioPrincipal },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingFirma: false });
        if (res.data.success === 2) {
          message.success('Firma borrada');
          this.setState({ firmaActual: null, firmaData: null });
          if (this.sigPad) this.sigPad.clear();
        } else {
          message.error('No se pudo borrar la firma');
        }
      })
      .catch(() => {
        this.setState({ loadingFirma: false });
        message.error('Error al borrar la firma');
      });
  }
  consultarFirma() {
    this.setState({ loadingFirma: true });
    axios
      .post(
        'usuarios/selectFirma',
        { usuarioPrincipal: this.props.usuarioPrincipal, usuarioId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingFirma: false, firmaActual: res.data.firma || null });
      })
      .catch(() => this.setState({ loadingFirma: false }));
  }
  consultarHistoricoFirmas() {
    this.setState({ loadingHistorico: true });
    axios
      .post(
        'usuarios/selectHistoricoFirmas',
        { usuarioPrincipal: this.props.usuarioPrincipal, usuarioId: this.props.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ historicoFirmas: res.data.historico || [], loadingHistorico: false });
      })
      .catch(() => this.setState({ loadingHistorico: false }));
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "usuarios/editarUsuario",
        {
          ...values,
          usuarioPrincipal: this.props.usuarioPrincipal,
          usuarioId: this.props.id,
          permisosUsuario: this.state.permisosUsuario,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data?.success === 2) {
          message.success("Se ha editado un usuario");
          this.formRef.current.resetFields();
          this.setState({ permisosUsuario: [], perfilIdSel: null });
          this.cerrarEditarUsuario();
        } else if (res.data.nombre === 1) {
          message.error('El nombre ya existe');
        } else if (res.data.error) {
          message.error(res.data.error);
        } else {
          message.error('Ha sucedido un error y no se pudo editar el usuario');
        }
      });
  }
  render() {
    const esMiUsuario = this.props.id === this.props.usuarioId;

    const firmaTab = (
      <>
        {/* Fila superior: selector de modo + botones de acción */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
          <SegmentedItem
            value={this.state.firmaMode}
            onChange={(val) => {
              this.setState({ firmaMode: val, firmaData: null }, () => {
                if (val === 'dibujar') this.initSignaturePad();
              });
            }}
            options={[
              { label: 'Subir imagen', value: 'subir', icon: <UploadOutlined /> },
              { label: 'Dibujar', value: 'dibujar', icon: <EditOutlined /> },
            ]}
          />
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Popconfirm
              title="¿Seguro que quieres borrar la firma?"
              onConfirm={this.borrarFirma.bind(this)}
              okText="Sí"
              cancelText="No"
            >
              <ButtonItem size="small" rojo icon={<DeleteOutlined />} loading={this.state.loadingFirma}>
                Borrar
              </ButtonItem>
            </Popconfirm>
            <ButtonItem
              size="small"
              gris
              icon={<ClearOutlined />}
              onClick={() => {
                if (this.state.firmaMode === 'dibujar') {
                  if (this.sigPad) this.sigPad.clear();
                } else {
                  this.setState({ firmaData: null });
                }
              }}
            >
              Limpiar
            </ButtonItem>
            <ButtonItem
              size="small"
              cyan
              icon={<SafetyCertificateOutlined />}
              loading={this.state.loadingFirma}
              onClick={this.guardarFirma.bind(this)}
            >
              Guardar Firma
            </ButtonItem>
          </div>
        </div>

        {/* Dos columnas: firma actual | nueva firma */}
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          {/* Columna izquierda: firma actual */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>Firma actual:</div>
            {this.state.firmaActual ? (
              <img
                src={this.state.firmaActual}
                alt="Firma actual"
                style={{ maxHeight: 150, maxWidth: '100%', border: '1px solid #d9d9d9', borderRadius: 4, padding: 4, background: '#fff' }}
              />
            ) : (
              <div style={{ height: 150, border: '1px dashed #d9d9d9', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb', fontSize: 13 }}>
                Sin firma registrada
              </div>
            )}
          </div>

          {/* Columna derecha: nueva firma */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>Nueva firma:</div>
            {this.state.firmaMode === 'subir' ? (
              <div>
                <Upload
                  accept="image/png,image/jpeg"
                  showUploadList={false}
                  beforeUpload={(file) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                      const img = new Image();
                      img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        canvas.getContext('2d').drawImage(img, 0, 0);
                        this.setState({ firmaData: canvas.toDataURL('image/png') });
                      };
                      img.src = e.target.result;
                    };
                    reader.readAsDataURL(file);
                    return false;
                  }}
                >
                  <ButtonItem icon={<UploadOutlined />}>Seleccionar imagen (PNG / JPG)</ButtonItem>
                </Upload>
                {this.state.firmaData && (
                  <div style={{ marginTop: 8 }}>
                    <img
                      src={this.state.firmaData}
                      alt="Vista previa"
                      style={{ display: 'block', maxHeight: 140, maxWidth: '100%', border: '1px solid #d9d9d9', borderRadius: 4, padding: 4, background: '#fff' }}
                    />
                  </div>
                )}
              </div>
            ) : (
              <canvas
                ref={this.canvasRef}
                width={460}
                height={150}
                style={{ border: '1px solid #d9d9d9', borderRadius: 4, touchAction: 'none', cursor: 'crosshair', display: 'block', maxWidth: '100%' }}
              />
            )}
          </div>
        </div>

        {/* Historial colapsable */}
        {this.state.historicoFirmas.length > 0 && (
          <Collapse ghost style={{ marginTop: 8 }}>
            <Collapse.Panel
              header={`Historial de firmas (${this.state.historicoFirmas.length})`}
              key="historial"
            >
              <div style={{ display: 'flex', gap: 12, overflowX: 'auto', paddingBottom: 8 }}>
                {this.state.historicoFirmas.map((h, i) => (
                  <div key={i} style={{ minWidth: 160, textAlign: 'center', flexShrink: 0 }}>
                    <img
                      src={h.firma}
                      alt={`Firma ${i + 1}`}
                      style={{ maxHeight: 100, maxWidth: 150, border: '1px solid #d9d9d9', borderRadius: 4, padding: 4, background: '#fff' }}
                    />
                    <div style={{ fontSize: 11, color: '#888', marginTop: 4 }}>
                      {new Date(h.fechaSubida).toLocaleDateString('es-MX', {
                        day: '2-digit', month: 'short', year: 'numeric',
                        hour: '2-digit', minute: '2-digit',
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </Collapse.Panel>
          </Collapse>
        )}
      </>
    );

    const tabs = [
      {
        key: '1',
        label: 'General',
        forceRender: true,
        customContent: (
          <>
            <FormItem
              label="Perfil"
              name="perfilId"
              required
              tooltip={esMiUsuario ? "No puedes cambiar tu propio perfil" : undefined}
            >
              <SelectItem placeholder="Perfil" disabled={!this.props.permisoAsignarPerfil || esMiUsuario}>
                {this.state.objetoPerfiles}
              </SelectItem>
            </FormItem>
            <FormItem label="Nombre">
              <Input.Group compact>
                <FormItem name="nombre" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Nombre" prefix={<UserOutlined className="site-form-item-icon" />} />
                </FormItem>
                <FormItem name="apellidoPaterno" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Apellido P." />
                </FormItem>
                <FormItem name="apellidoMaterno" noStyle pattern required max={200}>
                  <Input style={{ width: "33%" }} placeholder="Apellido M." />
                </FormItem>
              </Input.Group>
            </FormItem>
            <FormItem name="nombreUsuario" label="Nombre Usuario" pattern required max={200} min={5}>
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Nombre de usuario"
                disabled={!this.props.permisoCambiarNombreUsuario}
              />
            </FormItem>
            <FormItem name="esVendedor" label="Vendedor" tooltip="Activar si el usuario es un vendedor." valuePropName="checked" initialValue={false}>
              <SwitchItem />
            </FormItem>
            <FormItem name="departamentos" label="Departamentos" initialValue={[]}>
              <SelectItem mode="multiple" placeholder="Departamentos del usuario" options={this.state.opcionesDepartamentos || []} />
            </FormItem>
          </>
        ),
      },
      {
        key: '5',
        label: 'Proyectos',
        forceRender: true,
        customContent: (
          <>
            <FormItem name="proyectos" valuePropName="targetKeys">
              <TransferItem
                dataSource={(this.state.todasProyectos || []).flatMap((empresa) =>
                  empresa.proyectos.map((proyecto) => ({
                    key: proyecto._id,
                    title: proyecto.nombre,
                    description: empresa.nombre,
                  }))
                )}
                filterOption={(inputValue, item) =>
                  item.title.toLowerCase().includes(inputValue.toLowerCase()) ||
                  item.description.toLowerCase().includes(inputValue.toLowerCase())
                }
                render={(item) => (item.description ? `${item.title} (${item.description})` : item.title)}
                titles={["Disponibles", "Asignados"]}
                disabled={!this.props.permisoAsignarProyecto}
              />
            </FormItem>
            <FormItem
              name="limitarProyectos"
              label="Limitar acceso a proyectos"
              tooltip="Al activar esta opción, el usuario solo podrá ver los proyectos seleccionados arriba y no el resto de los proyectos de la empresa. Si se deja desactivado, podrá ver todos los proyectos de las empresas a las que tiene acceso."
              valuePropName="checked"
              initialValue={false}
            >
              <SwitchItem disabled={!this.props.permisoAsignarProyecto} />
            </FormItem>
            <LeyendaModulosLimitarProyectos />
          </>
        ),
      },
      {
        key: '2',
        label: 'Avanzado',
        forceRender: true,
        customContent: (
          <>
            <FormItem label="Rfc" name="rfc" rfc margin>
              <InputItem placeholder="Registro Federal de Contribuyentes" />
            </FormItem>
            <FormItem label="Curp" name="curp" curp margin>
              <InputItem placeholder="Clave Unica de Registro de Poblacion" />
            </FormItem>
            <FormItem label="Celular" name="celular" number margin>
              <InputNumberItem placeholder="Celular" celular />
            </FormItem>
            <FormItem label="Telefono" name="telefono" number margin>
              <InputNumberItem placeholder="Telefono" celular />
            </FormItem>
            <FormItem label="Nss" name="nss" margin>
              <InputItem placeholder="Numero seguro social" />
            </FormItem>
            <FormItem label="Correo de Contacto" tooltip="Correo al que se enviarán los avisos del sistema" name="correoContacto" pattern required max={200} email>
              <InputItem prefix={<MailOutlined className="site-form-item-icon" />} placeholder="Correo" />
            </FormItem>
            <FormItem label="Observaciones" name="observaciones" margin pattern>
              <TextAreItem placeholder="Observaciones" />
            </FormItem>
          </>
        ),
      },
      {
        key: '4',
        label: 'Firma digital',
        forceRender: true,
        customContent: firmaTab,
      },
      ...(this.props.permisoAsignarPermisos && !esMiUsuario ? [{
        key: '3',
        label: 'Permisos',
        forceRender: true,
        customContent: (
          <PermisosUsuarioEditor
            perfilId={this.state.perfilIdSel}
            overrides={this.state.permisosUsuario}
            onChange={(permisosUsuario) => this.setState({ permisosUsuario })}
          />
        ),
      }] : []),
    ];

    return (
      <>
        <ModalItem
          title="Editar Usuario"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={this.cerrarEditarUsuario.bind(this)}
          paddingTop
        >
          <Form
            ref={this.formRef}
            name="agregarUsuario"
            layout
            onValuesChange={this.onChangeValoresForm}
            bottom={
              <Button
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Guardar
              </Button>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <TabbedDynamicTable
              tabs={tabs}
              defaultActiveKey="1"
              onTabChange={(key) => {
                if (key === '4') {
                  this.consultarFirma();
                  this.consultarHistoricoFirmas();
                  this.initSignaturePad();
                }
              }}
            />
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    usuarioPrincipal: state.user.usuarioPrincipal,
    usuarioId: state.user.usuarioId,
    empresaId: state.empresa.id,
    permisoAsignarProyecto:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6a23144f903358dc7da8a8be"
      )?.activado,
    permisoAsignarPerfil:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6a2314ae903358dc7da8a96f"
      )?.activado,
    permisoAsignarPermisos:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6a2314cc903358dc7da8a98e"
      )?.activado,
    permisoCambiarNombreUsuario:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) => valueTodos.permisoId.toString() === "6a2314e8903358dc7da8a992"
      )?.activado,
  };
};

export default connect(mapStateToProps)(EditarUsuario);
